<template lang="pug">
.trainer-view-outer-wrapper(:class="'context-'+context")
  include TrainerView.pug
</template>

<script>
import _ from 'underscore'
import { mapState } from 'vuex'
import moment from 'moment'
import Api from './services/Api'
import TrainerDetailAddress from '@/components/trainer_detail_address/TrainerDetailAddress'
import TrainerViewCategoriasRegistro from '@/components/TrainerViewCategoriasRegistro'
import TrainerTitle from '@/components/trainer_title/TrainerTitle'
import TrainerRegisterCategoriesPublic from '@/components/TrainerRegisterCategoriesPublic'
import Trainer from '@/components/Trainer'
import Conocimientos from '@/components/Conocimientos'
import PermissionsMixin from "@/mixins/Permissions";
import S from 'string'
import voca from 'voca'
import Url from 'url-parse'

export default {
  name: 'TrainerView',
  mixins: [PermissionsMixin],
  components: {
    TrainerDetailAddress,
    TrainerTitle,
    Trainer,
    TrainerRegisterCategoriesPublic,
    TrainerViewCategoriasRegistro,
    Conocimientos
  },
  computed: mapState([
    "context", "token",
  ]),
  data() {
    return {
      publicView: true,
      about_me: null,
      trainer: null,
      profileImage: null,
      editEnabled: false,
      cecs: [],
      specs: [],
      subscribedSpecs: [],
      socialTitle: '',
      socialDescription: '',
      socialHashtags: 'esreps,profesional',
      currentUrl: '',
      actionImage: '',
      actionPartialUpdate: '',
      actionFormacion: '',
      currentToken: '',
      plan: null,
      // Add formacion
      course: {
        name: '',
        school: '',
        category: '',
        subcategory: '',
        course: '',
        courses: [],
      },
    }
  },
  mounted() {
    //- FALTA HACER QUE SE LLAME A ESTE SCRIPT PARA LOS INPUT FILES!!!
    $('input[type=file]').change(function() {
      var filename = jQuery(this)
        .val()
        .split('\\')
        .pop()
      var idname = jQuery(this).attr('id')
      $('span.' + idname)
        .next()
        .find('span')
        .html(filename)
      $('span.' + idname)
        .next()
        .find('i')
        .removeClass('fa-upload')
        .addClass('fa-check')
      $('label[for=' + idname + ']').addClass('background-upload')
    })
  },
  computed: _.extend(mapState(['context']), {
    expired: function() {
      let licenses = this.trainer.licenses
      if (!licenses.length) return true
      let firstLicense = licenses[0]
      let expiration = moment(firstLicense.expiration_date)
      return expiration.isBefore(moment())
    },
    onlyCecs: function() {
      const onlyCecsLegacy =
        _.filter(this.trainer.courses, item => {
          return !_.isEmpty(item.level_course_title)
        }).length == 0
      const coursesV2 = this.trainer.courses_v2
      let hasV2Level = false
      if (_.isArray(coursesV2) && !_.isEmpty(coursesV2)) {
        for (const item of coursesV2) {
          if (!_.isEmpty(item.level)) hasV2Level = true
        }
      }
      return onlyCecsLegacy && !hasV2Level
    },
  }),
  async created() {
    const _this = this
    this.token = this.$store.state.token
    let id = this.$route.params.id
    this.currentUrl = `${window.location.href}`

    if (/filesuccess/.test(this.currentUrl)) {
      setTimeout(function() {
        _this.$notify({
          group: 'esreps',
          title: 'Fichero subido',
          type: 'success',
          text: 'Se ha subido el fichero correctamente',
        })
      }, 1500)
    }

    const token = this.$store.state.token

    // calculate the post url for the image
    this.actionImage = `${Api.getApiUrl()}/esreps/file-partial-update-user/?token=${token}`
    this.actionPartialUpdate = `${Api.getApiUrl()}/esreps/partial-update-user/?token=${token}`
    this.actionFormacion = `${Api.getApiUrl()}/esreps/add-formacion/?token=${token}`

    // Check if its public view or it is inside the dashboard
    this.editEnabled = false
    this.publicView == !/\/dashboard\//.test(window.location.href)

    if (/\/dashboard\//.test(window.location.href)) {
      // the id is getted from the me service
      this.editEnabled = true

      const meResponse = await Api.me(this.token)
      const meData = meResponse.data
      this.subscribedSpecs = _.map(meData.specs, item => {
        return parseInt(item.pk, 10)
      })
      this.plan = meData.plan
      this.loadTrainer(meData.pk)
    } else {
      this.editEnabled = false
      this.loadTrainer(id)
    }

    // get the specs
    const specsResponse = await Api.specs()
    this.specs = specsResponse.data.items
  },
  methods: {
    hasImage() {
      return _.contains(this.profileImage, 'avatar')
    },
    loadTrainer(id) {
      const _this = this

      let min = 1
      let max = 15
      let randomIntegerImage = Math.floor(Math.random() * (max - min + 1) + min)
      let randomImage =
        '/static/img/avatar/avatar-perfil-' + randomIntegerImage + '.png'

      Api.getTrainerDetail(id)
        .then(response => {
          _this.trainer = response.data
          const plan = _this.trainer.plan
          _this.plan = plan

          if (_this.trainer.profile_photo_path) {
            _this.profileImage = _this.trainer.profile_photo_path
          }

          if (!_this.profileImage) {
            _this.profileImage = randomImage
          }

          _this.cecs = _.filter(response.data.courses, item => {
            return !_.isEmpty(item.level_course)
          })
        })
        .catch()
    },
    hasLevel(level) {
      let stringLevel = `${level}`
      let hasLevel = false
      _.each(this.trainer.courses, course => {
        if (stringLevel == `${course.level}`) hasLevel = true
      })
      return hasLevel
    },
    saveAboutMe() {
      const _this = this

      let partialData = {
        about_me: this.trainer.about_me,
      }

      Api.userPartialUpdate(partialData, this.$store.state.token)
        .then(response => {
          _this.$notify({
            group: 'esreps',
            title: 'Datos actualizados',
            type: 'success',
            text:
              'Se han actualizados los datos correctamente en la base de datos',
          })
        })
        .catch(err => {})
    },
  },
  watch: {
    'course.category': async function(newValue, oldValue) {
      const response = await Api.getSubcategories(newValue)
      const data = response.data
      const items = data.items
      this.course.courses = items
    },
  },
  filters: {
    outputlimited(value) {
      if (_.isEmpty(value)) return ''
      let maxLimit = 1200
      let totalLength = value.length
      if (totalLength < maxLimit) return value
      let limitedString = S(value).left(maxLimit) + '...'
      return limitedString
    },
  },
}
</script>

<style scoped lang="scss">
@import './../variables';
@import '../variables_colreps';
@import '../variables_mexreps';

@import './TrainerView';

.context-colreps {
  @import 'TrainerViewColreps';
}

.context-mexreps {
  @import 'TrainerViewMexreps';
}
</style>



// WEBPACK FOOTER //
// src/components/TrainerView.vue